export default "__VITE_ASSET__bf83589d__"